import React from "react";
import { Checkbox as CheckboxComponent, Form } from "semantic-ui-react";

const CheckboxInput = ({ input, label, width, ...custom }) => (
  <Form.Field
    control={CheckboxComponent}
    label={label}
    width={width}
    checked={!!input.value}
    onClick={(event, data) => input.onChange(data.checked)}
    {...custom}
  />
);

export default CheckboxInput;
